export default {
  'dept.title': "Nom de l'entreprise",
  'dept.btn.add': 'Ajouter une entreprise',
  'dept.btn.addSubsidiary': 'Ajouter une filiale',
  'dept.btn.edit': "Modifier l'entreprise",
  'dept.btn.del': "Supprimer l'entreprise",
  'dept.input.dept.placeholder': "Veuillez saisir le nom de l'entreprise",
};
